import { render, staticRenderFns } from "./farmersummary.vue?vue&type=template&id=b77c89ae&scoped=true"
import script from "./farmersummary.vue?vue&type=script&lang=js"
export * from "./farmersummary.vue?vue&type=script&lang=js"
import style0 from "./farmersummary.vue?vue&type=style&index=0&id=b77c89ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c89ae",
  null
  
)

export default component.exports